import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { Label } from "reactstrap";
import { AppConstants } from "../../models/AppConstants";


interface DeleteUserDialogProps {
  visible: boolean;
  onHide: () => void;
  onConfirm: (reason: string) => void;
  action:"SOFT_DELETE" | "HARD_DELETE" | "RESTORE" | null;
}

const MIN_REASON_LENGTH = 5;

const DeleteUserDialog: React.FC<DeleteUserDialogProps> = ({
  visible,
  onHide,
  onConfirm,
  action
}) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState<string | null>(null);

  const handleReasonChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const value = e.target.value;
    setReason(value);

    if (value.length < MIN_REASON_LENGTH) {
      setError("Reason must be at least 5 characters long");
    } else {
      setError(null);
    }
  };
 const getMessage = () => {
        switch (action) {
            case "HARD_DELETE":
                return "This action is irreversible. The user will be permanently deleted.";
            case "SOFT_DELETE":
                return "After confirming, the user will no longer be able to log in to their profile.";
            case "RESTORE":
                return "The user will be restored and reactivated.";
            default:
                return "";
        }
    };
  const handleConfirm = () => {
    if (reason.length < MIN_REASON_LENGTH) {
      setError("Reason must be at least 5 characters long");
      return;
    }

    onConfirm(reason);
    resetState();
  };

  const resetState = () => {
    setReason("");
    setError(null);
  };

  const handleHide = () => {
    resetState();
    onHide();
  };

  return (
    <Dialog
      header="Confirm Delete User"
      visible={visible}
      style={{ width: "40vw" }}
      modal
      onHide={handleHide}
      footer={
        <>
          <Button
            label="Cancel"
            icon="pi pi-times"
            onClick={handleHide}
            className="p-button-text"
          />
          <Button
            label="Confirm"
            icon="pi pi-check"
            onClick={handleConfirm}
            disabled={reason.length < MIN_REASON_LENGTH}
            className="p-button-danger"
          />
        </>
      }
    >
      <div>
        <div style={{ marginTop: "1rem" }}>
          <Label htmlFor="reason">Reason</Label>

          <InputTextarea
            id="reason"
            style={{ width: "100%" }}
            value={reason}
            onChange={handleReasonChange}
            className={error ? "p-invalid" : ""}
            minLength={MIN_REASON_LENGTH}
            maxLength={AppConstants.NotesAndReasonLength}
          />

          {error && (
            <div style={{ color: "red", fontSize: "0.8rem" }}>
              {error}
            </div>
          )}
        </div>

        <div
          style={{
            marginTop: "1.5rem",
            padding: "0.75rem",
            backgroundColor: "#ffe6e6",
            border: "1px solid #ff0000",
            borderRadius: "4px",
            color: "#900",
            fontWeight: "bold",
          }}
        >
        {getMessage()}
        </div>
      </div>
    </Dialog>
  );
};

export default DeleteUserDialog;
